import * as i0 from '@angular/core';
import * as i1 from './tabs.module';
import * as i2 from '@angular/common';
import * as i3 from './ng-transclude.directive';
import * as i4 from './tab.directive';
import * as i5 from './tabset.component';
import * as i6 from './tab-heading.directive';
export const TabsModuleNgFactory:i0.NgModuleFactory<i1.TabsModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.NgTranscludeDirective = (<any>(null as any));
var _decl0_12:i4.TabDirective = (<any>(null as any));
var _decl0_13:i5.TabsetComponent = (<any>(null as any));
var _decl0_14:i6.TabHeadingDirective = (<any>(null as any));
var _decl0_15:i2.AsyncPipe = (<any>(null as any));
var _decl0_16:i2.UpperCasePipe = (<any>(null as any));
var _decl0_17:i2.LowerCasePipe = (<any>(null as any));
var _decl0_18:i2.JsonPipe = (<any>(null as any));
var _decl0_19:i2.SlicePipe = (<any>(null as any));
var _decl0_20:i2.DecimalPipe = (<any>(null as any));
var _decl0_21:i2.PercentPipe = (<any>(null as any));
var _decl0_22:i2.TitleCasePipe = (<any>(null as any));
var _decl0_23:i2.CurrencyPipe = (<any>(null as any));
var _decl0_24:i2.DatePipe = (<any>(null as any));
var _decl0_25:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_26:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_27:i2.CommonModule = (<any>(null as any));
var _decl0_28:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_29:i0.ElementRef<any> = (<any>(null as any));
function _View_TabsetComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.clazz;
  currVal_0;
}
function _View_TabsetComponent_1_2():void {
  if (_any.removable) {
    var _any:any = (null as any);
    _any.preventDefault();
    const pd_0:any = ((<any>_decl0_13.removeTab(_any)) !== false);
  }
}
function _View_TabsetComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = ['nav-item',(_any.customClass || '')];
  currVal_0;
  const currVal_1:any = _any.active;
  currVal_1;
  const currVal_2:any = _any.disabled;
  currVal_2;
  const currVal_3:any = (_any.id? (_any.id + '-link'): '');
  currVal_3;
  const currVal_4:any = _any.active;
  currVal_4;
  const currVal_5:any = _any.disabled;
  currVal_5;
  const currVal_6:any = _any.headingRef;
  currVal_6;
  const currVal_7:any = _any.heading;
  currVal_7;
  const currVal_8:any = _any.removable;
  currVal_8;
  const pd_9:any = ((<any>(_any.active = true)) !== false);
}
function _View_TabsetComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'nav';
  currVal_0;
  const currVal_1:any = _decl0_13.classMap;
  currVal_1;
  const currVal_2:any = _decl0_13.tabs;
  currVal_2;
  const pd_3:any = ((<any>_any.preventDefault()) !== false);
}
